var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', {
    class: _vm.$props.customsClasses,
    style: _vm.style,
    attrs: {
      "elementType": "div"
    }
  }, [_c('custom-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$props.isSelected,
      expression: "$props.isSelected"
    }],
    staticClass: "icon-check-swatch",
    attrs: {
      "elementType": "span"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }